// Friendly labels for the engine's `exclusion_reason` values, grouped by source.
export const EXCLUSION_LABEL = {
  // is_included = 0 (PSC policy)
  site_excluded:           'Site',
  labor_metric_excluded:   'Labor Metric',
  cost_center_excluded:    'Cost Center',
  // LEGACY (reclassified to GAPS 2026-06-08): kept only so rows built before
  // the next reprocess still render a label instead of the raw key.
  inactive_employee:       'Inactive Employee',
  inactive_location:       'Inactive Location',
  inactive_department:     'Inactive Department',
  inactive_task_419:       'Inactive Project in NetSuite',
  inactive_service_item_420: 'Bill. Title/Service Item Mapping Record Inactive in NetSuite',
  inactive_rate_413:       'Inactive Price in NetSuite',
  // Every positive-hours line excluded by the rules — TAB06
  // ignore_for_billing = 1 for every pay entry, and/or TAB05 per-task
  // price-level exclusions covering every line (rollup added 2026-06-10).
  non_billable_payroll:    'Non-Billable Payroll',
  // No positive-hours billable line at all (2026-06-29) — adjustment companion
  // on a punch-owned day (real billing is on the punch record), or a punch day
  // with no summaries yet. Routed off Pending; self-corrects on reprocess if
  // Dayforce later produces lines.
  no_billable_content:     'No Billable Content',
  // Timesheet entry with NO Site Location, Job Assignment or Labor Task at all
  // (2026-07-28). Any ONE of those missing is still a fixable gap; all three
  // means there is no billing context to chase.
  no_dayforce_context:     'Missing Site, Job & Task in Dayforce',
  // Ops decision, not an engine rule (2026-07-28). Set by hand from Pending or
  // Gaps; survives every reprocess; reversible via Undo Exclusion.
  manually_excluded:       'Manually Excluded',
};

export const GAP_LABEL = {
  employee:         'Employee not in NetSuite',
  billing_title:    'Position/Job title not found in NetSuite Billing Titles',
  // Dayforce-side data holes (blank on the timesheet entry itself) — distinct
  // from the NetSuite-side mapping gaps below (billing-team request 2026-06-08).
  site_missing_dayforce: 'Site missing from Dayforce timesheet',
  task_missing_dayforce: 'Labor Task missing from Dayforce timesheet',
  // Position/Job blank on the Dayforce entry — can't derive a billing title.
  billing_title_missing_dayforce: 'Position/Job missing from Dayforce timesheet',
  location:         'Location not in NetSuite',
  task_419:         'Task / Cost Center mapping missing',
  // Duplicate active 419 records tie at a location and the engine can't pick
  // one (≥2 carry a billing task, or all are stubs) — clean up the dupes in NS.
  ambiguous_task_419: 'Duplicate Task / Cost Center mapping in NetSuite',
  project:          'No NetSuite Project linked to Task',
  // The 420 keys are about the MAPPING record (billing title ↔ service item
  // combo), not the item itself — mislabelling them as the item hid real
  // item-level problems (billing-team request 2026-06-12).
  service_item_420: 'Bill. Title/Service Item Mapping Record missing in NetSuite',
  rate_413:         'Price missing from Service Item in NetSuite',
  // No 413 record at all for this (item, location) — distinct from rate_413
  // (a record exists but its price is blank / future-dated).
  price_location_missing: 'Price/Location mapping missing in NetSuite',
  // LEGACY: $0 price levels stopped being gaps 2026-06-12 ($0 is intentional
  // pricing — e.g. CAD Holiday $0 = not billed); label kept for old rows.
  rate_zero:        'Price Level amount $0 on Service Item',
  // Item-level + title-level state, distinct from the mapping record above.
  // Inactive items are REJECTED by NetSuite at push time ("Invalid Field
  // Value <id> for the following field: item") — the gap catches it upstream.
  service_item_missing:   'Service Item missing in NetSuite',
  inactive_service_item:  'Service Item Inactive in NetSuite',
  inactive_billing_title: 'Billing Title Inactive in NetSuite',
  // Inactive NetSuite references (reclassified from exclusions 2026-06-08):
  // inactive means fixable in NetSuite, so these are gaps to resolve.
  inactive_employee:         'Inactive Employee in NetSuite',
  inactive_location:         'Inactive Location in NetSuite',
  inactive_department:       'Inactive Department in NetSuite',
  inactive_task_419:         'Inactive Project in NetSuite',
  inactive_service_item_420: 'Bill. Title/Service Item Mapping Record Inactive in NetSuite',
  inactive_rate_413:         'Inactive Price in NetSuite',
};
